import { getCookie, setCookie } from '@client/helpers/cookie';

const SEC_SUB_CLOSED_COOKIE = 'zl_secsub_closed';
const SEC_SUB_ENABLED_COOKIE = 'zl_secsub_enabled';

const DAY = 1000 * 60 * 60 * 24;
const DELAY_CLOSED = DAY * 30;
const DELAY_HIDDEN = DAY;

export const setSubscriptionCookie = (delay: number) =>
    setCookie(SEC_SUB_CLOSED_COOKIE, 'true', delay);

export const getSubscriptionCookie = (): boolean => !!getCookie(SEC_SUB_CLOSED_COOKIE);

export const setSubscriptionHiddenCookie = (): void => setSubscriptionCookie(DELAY_HIDDEN);
export const setSubscriptionClosedCookie = (): void => setSubscriptionCookie(DELAY_CLOSED);

export const hasSubscriptionEnabledCookie = (): boolean => !!getCookie(SEC_SUB_ENABLED_COOKIE);
